/**
 * iQuickCalc Validation Schema
 */

import { z } from 'zod';
import { evaluateExpression } from '../shared';

export const schema = z.object({
  project: z.string().min(1, 'Project name is required'),
  title: z.string().min(1, 'Title is required'),

  length: z.string().refine(s => {
    const n = evaluateExpression(s);
    return n !== null && n > 0;
  }, 'Length must be a valid expression greater than 0'),

  tribWidth: z.string().refine(s => {
    const n = evaluateExpression(s);
    return n !== null && n > 0;
  }, 'Tributary width must be a valid expression greater than 0'),

  hingeLength: z.string().refine(s => {
    const n = evaluateExpression(s);
    return n !== null && n > 0;
  }, 'Hinge length must be a valid expression greater than 0'),

  totalWeight: z.string().refine(s => {
    const n = evaluateExpression(s);
    return n !== null && n >= 0;
  }, 'Total weight must be a valid expression greater than or equal to 0'),

  klmFactor: z.string().refine(s => {
    const n = evaluateExpression(s);
    return n !== null && n >= 0;
  }, 'KLM factor must be a valid expression greater than or equal to 0'),

  Ru: z.string().refine(s => {
    const n = evaluateExpression(s);
    return n !== null && n > 0;
  }, 'Ru must be a valid expression greater than 0'),

  Xe: z.string().refine(s => {
    const n = evaluateExpression(s);
    return n !== null && n > 0;
  }, 'Xe must be a valid expression greater than 0'),

  LoadType: z.string().refine(s => ['0', '1', '2', '3'].includes(s), 'Load type must be 0 (Triangular), 1 (Triangular Pulse), 2 (Rectangular), or 3 (Gradually Applied Load)'),

  Pa: z.string().refine(s => {
    const n = evaluateExpression(s);
    return n !== null && n > 0;
  }, 'Pa must be a valid expression greater than 0'),

  td: z.string().refine(s => {
    const n = evaluateExpression(s);
    return n !== null && n > 0;
  }, 'Duration must be a valid expression greater than 0')
});

export type FormValues = z.infer<typeof schema>;
export type ParsedValues = z.output<typeof schema>;
export type FormErrors = z.inferFlattenedErrors<typeof schema>['fieldErrors'];
export type FieldName = keyof FormValues;
